import React, { useState } from "react";
import { Box, Fab, useScrollTrigger } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const ScrollToTopButton: React.FC = () => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 80,
  });

  const [touched, setTouched] = useState(false);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Detect if device is touch (mobile/tablet)
  const isTouchDevice =
    typeof window !== "undefined" &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0);

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 32,
        right: "5vw",
        zIndex: 1300,
        display: trigger ? "flex" : "none",
      }}
    >
      <Fab
        onClick={handleClick}
        onTouchStart={() => setTouched(true)}
        onTouchEnd={() => setTouched(false)}
        onMouseLeave={() => setTouched(false)}
        sx={{
          background: touched ? "#1976d2" : "#294959",
          color: "#fff",
          width: 56,
          height: 56,
          boxShadow: 3,
          borderRadius: 2,
          minHeight: 56,
          minWidth: 56,
          transition: "background 0.2s",
          "&:hover": {
            background: isTouchDevice ? undefined : "#1976d2",
          },
        }}
        aria-label="Scroll to top"
      >
        <KeyboardArrowUpIcon sx={{ fontSize: 32 }} />
      </Fab>
    </Box>
  );
};

export default ScrollToTopButton;
